import React from "react";
import DatePicker from "react-datepicker";
import { useField, useFormikContext } from "formik";
import { getTip } from "../helpers";

export function CustomDatePicker({
  tip,
  testId,
  dateFormat = "dd/MM/yyyy",
  placeholderText = "Select Date",
  popperPlacement="bottom",
  ...other
}) {
  return (
    <div data-testid={testId}>
      <DatePicker
        popperPlacement={popperPlacement}
        dateFormat={dateFormat}
        placeholderText={placeholderText}
        {...other}
        className="form-control"
      />
      {tip && <div>{tip}</div>}
    </div>
  );
}

export const MappedDatePicker = ({ ...props }) => {
  const { setFieldValue } = useFormikContext();
  const [field, meta] = useField(props);

  return (
    <CustomDatePicker
      {...field}
      {...props}
      selected={(field.value && new Date(field.value)) || null}
      className="form-control"
      onChange={(val) => {
        const date = val ? new Date(val) : "";
        setFieldValue(field.name, date);
      }}
      tip={getTip(meta, props.tip)}
    />
  );
};
